import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "team-member-description-card d-flex align-center elevation-1 rounded-sm gr-2",
    },
    [
      _c(VImg, {
        staticClass: "flex-grow-0 mt-auto rounded-circle",
        attrs: {
          "lazy-src": "/static/_v1/pd/pictures/stubs/person-photo.png",
          alt: `${_setup.transDynamic(
            _vm.teamMember,
            `first_name,${_setup.language},${_setup.needTranslate}`
          )} ${_setup.transDynamic(
            _vm.teamMember,
            `last_name,${_setup.language},${_setup.needTranslate}`
          )} ${_setup.transDynamic(
            _vm.teamMember,
            `position,${_setup.language},${_setup.needTranslate}`
          )}`,
          src: _vm.teamMember.photo.url,
          width: "200",
          height: "200",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column gr-2" }, [
        _c("h5", { staticClass: "text-h5 text--text" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _setup.transDynamic(
                  _vm.teamMember,
                  `first_name,${_setup.language},${_setup.needTranslate}`
                )
              ) +
              "\n      " +
              _vm._s(
                _setup.transDynamic(
                  _vm.teamMember,
                  `last_name,${_setup.language},${_setup.needTranslate}`
                )
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-body-2 text--text" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _setup.transDynamic(
                  _vm.teamMember,
                  `position,${_setup.language},${_setup.needTranslate}`
                )
              ) +
              "\n    "
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }